import { Box, CircularProgress } from '@mui/material';

const ProgressCircle = () => {
  return (
    <Box sx={{ display: 'flex' }}>
      <CircularProgress />
    </Box>
  );
};

export default ProgressCircle;
